import axios from 'axios';

export default {
    async list() {
        let response = await axios.get('/api/watchLists');
        return response.data;
    },
    async get(id) {
        let response = await axios.get(`/api/watchLists/${id}`);
        return response.data;
    },
    async create(watchList) {
        let response = await axios.post('/api/watchLists', watchList);
        return response.data;
    },
    async update(watchList) {
        let response = await axios.patch(`/api/watchLists/${watchList.id}`, watchList);
        return response.data;
    },
    async delete(watchList) {
        let response = await axios.delete(`/api/watchLists/${watchList.id}`);
        return response.data;
    },
    async addAmazonProduct(watchList, amazonProduct) {
        let response = await axios.post(`/api/watchLists/${watchList.id}/amazonProducts/${amazonProduct.id}`);
        return response.data;
    },
    async removeAmazonProduct(watchList, amazonProduct) {
        let response = await axios.delete(`/api/watchLists/${watchList.id}/amazonProducts/${amazonProduct.id}`);
        return response.data;
    },
}
